import React, { useEffect, useState } from "react";
import "./Servicos_disponiveis.css";

const API_URL = process.env.REACT_APP_API_URL;

const Servicos_disponiveis = () => {
  const [servicos, setServicos] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [servicoSelecionado, setServicoSelecionado] = useState(null);
  const [usuarioDono, setUsuarioDono] = useState(null);
  const [nomeBusca, setNomeBusca] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(0);
  const [temMaisPaginas, setTemMaisPaginas] = useState(false);

  const size = 5;

  const carregarServicos = () => {
    const token = localStorage.getItem("token");
    const url = `${API_URL}/servicos?nome=${nomeBusca}&sort=id,desc&page=${paginaAtual}&size=${size}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erro ao buscar serviços");
        return res.json();
      })
      .then((data) => {
        setServicos(data.content || []);
        setTemMaisPaginas(!data.last);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    carregarServicos();
  }, [nomeBusca, paginaAtual]);

  const abrirModal = (servico) => {
    setServicoSelecionado(servico);
    buscarUsuario(servico.idUsuario);
    setModalAberto(true);
  };

  const buscarUsuario = (idUsuario) => {
    const token = localStorage.getItem("token");

    fetch(`${API_URL}/usuarios/${idUsuario}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erro ao buscar usuário");
        return res.json();
      })
      .then((data) => setUsuarioDono(data))
      .catch((err) => console.error(err));
  };

  const fecharModal = () => {
    setModalAberto(false);
    setServicoSelecionado(null);
    setUsuarioDono(null);
  };

  const handleBuscar = (e) => {
    e.preventDefault();
    setPaginaAtual(0);
    carregarServicos();
  };

  const proximaPagina = () => {
    if (temMaisPaginas) setPaginaAtual((prev) => prev + 1);
  };

  const paginaAnterior = () => {
    if (paginaAtual > 0) setPaginaAtual((prev) => prev - 1);
  };

  return (
    <div className="servicos-container">

      <div className="banner-video-container">
        <video
          className="banner-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/banner.mp4" type="video/mp4" />
          Seu navegador não suporta vídeo.
        </video>
      </div>



      <form onSubmit={handleBuscar} className="busca-container">
        <input
          type="text"
          className="busca-input"
          placeholder="O que você procura?"
          value={nomeBusca}
          onChange={(e) => setNomeBusca(e.target.value)}
        />
        <button type="submit" className="busca-botao">Buscar</button>
      </form>

      <div className="servicos-grid">
        {servicos.map((servico) => (
          <div
            key={servico.id}
            className="servico-card"
            onClick={() => abrirModal(servico)}
          >
            <div className="servico-conteudo">
              {/* Parte superior */}
              <div className="servico-topo">
                <span className={`status-badge ${servico.ativo ? "status-ativo" : "status-inativo"}`}>
                  {servico.ativo ? "✅ Ativo" : "❌ Inativo"}
                </span>
                <h3 className="servico-nome">{servico.nome}</h3>
                <p className="servico-descricao">{servico.descricao}</p>
              </div>

              {/* Parte inferior */}
              <div className="servico-inferior">
                <p className="servico-info">📍 {servico.cidade}, {servico.uf} • 📚 {servico.categoria}</p>
                <p className="servico-data">🕒 {new Date(servico.dataHora).toLocaleString("pt-BR")}</p>
                <div className="servico-preco">💲 R$ {servico.preco.toFixed(2)}</div>
              </div>
            </div>

            {servico.imagem?.secureUrl && (
              <img
                src={servico.imagem.secureUrl}
                alt={servico.nome}
                className="servico-imagem"
              />
            )}
          </div>
        ))}
      </div>

      {paginaAtual > 0 &&(
      <div className="paginacao-container">
        <button
          onClick={paginaAnterior}
          className="paginacao-botao"
          disabled={paginaAtual === 0}
        >
          Anterior
        </button>
        <span className="paginacao-numero">{paginaAtual + 1}</span>
        <button
          onClick={proximaPagina}
          className="paginacao-botao"
          disabled={!temMaisPaginas}
        >
          Próxima
        </button>
      </div>
      )}

      {modalAberto && servicoSelecionado && (
        <div className="modal-overlay" onClick={fecharModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <p>{servicoSelecionado.ativo ? "✅ Ativo" : "❌ Inativo"}</p>
            <h2>{servicoSelecionado.nome}</h2>

            {servicoSelecionado.imagem?.secureUrl && (
              <img
                src={servicoSelecionado.imagem.secureUrl}
                alt={servicoSelecionado.nome}
                className="modal-imagem"
                style={{
                  width: "290px",
                  height: "auto",
                  display: "block", // importante para usar margin auto
                  margin: "0 auto", // centraliza horizontalmente
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "10px"
                }}

              />
            )}

            <p>{servicoSelecionado.descricao}</p>
            <p>💲 R$ {servicoSelecionado.preco.toFixed(2)}</p>
            <br></br>
            <p>📍{servicoSelecionado.bairro}, {servicoSelecionado.cidade}/{servicoSelecionado.uf}    • 📚{servicoSelecionado.categoria}</p>
            <p>🕒{new Date(servicoSelecionado.dataHora).toLocaleString("pt-BR")}</p>

            {servicoSelecionado.ativo && usuarioDono && (
              <>
                <br></br>
                <h3 style={{ marginTop: "15px" }}>Contato do Anunciante</h3>
                <p><strong>Nome:</strong> {usuarioDono.nome} {usuarioDono.sobrenome} <strong>Cel:</strong> {usuarioDono.celular} <strong>E-mail:</strong> {usuarioDono.email}</p>
              </>
            )}

            <button className="fechar-btn-servicos" onClick={fecharModal}>Fechar</button>
          </div>
        </div>
      )}


    </div>
  );
};

export default Servicos_disponiveis;
